import { create } from "zustand";

export type Exchange =
  | "binance"
  | "bybit"
  | "okx"
  | "kraken"
  | "coinbase"
  | "kucoin"
  | "gateio"
  | "bitget";

export type Timeframe = "1m" | "5m" | "15m" | "1h" | "4h" | "1d";

interface ChartStore {
  symbol: string;
  exchange: Exchange;
  timeframe: Timeframe;
  setSymbol: (symbol: string) => void;
  setExchange: (exchange: Exchange) => void;
  setTimeframe: (timeframe: Timeframe) => void;
  setAll: (next: { symbol: string; exchange: Exchange; timeframe: Timeframe }) => void;
}

export const useChartStore = create<ChartStore>((set) => ({
  symbol: "BTCUSDT",
  exchange: "binance",
  timeframe: "15m",
  setSymbol: (symbol) => set({ symbol }),
  setExchange: (exchange) => set({ exchange }),
  setTimeframe: (timeframe) => set({ timeframe }),
  setAll: (next) => set(next),
}));
